import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TuiEditor from '../../../components/common/TuiEditor';
import styles from './NoticeCreate.module.css';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';

export default function NoticeCreate() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 공지사항 생성 핸들러
  const handleNoticeSubmit = async (editorContent, editorTitle) => {
    // 제목 검증
    if (!editorTitle || !editorTitle.trim()) {
      alert('제목을 입력해주세요.');
      return Promise.reject(new Error('제목이 필요합니다.'));
    }

    // 내용 검증
    if (!editorContent || !editorContent.trim()) {
      alert('내용을 입력해주세요.');
      return Promise.reject(new Error('내용이 필요합니다.'));
    }

    setIsSubmitting(true);
    try {
      const noticeData = {
        title: editorTitle.trim(),
        content: editorContent
      };

      console.log('생성할 공지사항 데이터:', noticeData);

      // 실제로는 여기서 API 호출
      // await createNoticeAPI(noticeData);

      const response = await axios.post(`${API_BASE_URL}/api/v1/admin/notice`, noticeData, {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true // 세션 기반 인증 필수
      });

      const resData = response.data;

      if (resData.code === 1) {
        alert('공지사항이 성공적으로 등록되었습니다.');
        // 성공 시 공지사항 목록으로 이동
      navigate('/notices');
      return true;
      } else {
        alert('공지사항 등록에 실패했습니다.');
        return Promise.reject(new Error('API 실패'));
      }
    } catch (error) {
      console.error('공지사항 생성 오류:', error);
      alert('공지사항 생성 중 오류가 발생했습니다.');
      return Promise.reject(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <TuiEditor 
        onSubmit={handleNoticeSubmit} 
        isSubmitting={isSubmitting}
        submitButtonText="등록하기"
      />
    </div>
  );
}